import { createUncompletedActionsCarouselContainer } from './container'
import { UncompletedActionsCarousel as UIComponent } from './ui/uncompleted-actions-carousel'

const UncompletedActionsCarouselContainer = createUncompletedActionsCarouselContainer(UIComponent)

export const UncompletedActionsCarousel = ({ openBecomeAffiliateModal }: { openBecomeAffiliateModal: () => void }) => {
  return <UncompletedActionsCarouselContainer openBecomeAffiliateModal={openBecomeAffiliateModal} />
}
